import requestv2 from "~/utils/http-v2";

const documentApi = {
    getsGroup : async (params) => {
        const url = 'v2/documents/group';
        return await requestv2.get(url, {params});
    },
    addGroup : async (params) => {
        const url = 'v2/documents/group';
        return await requestv2.post(url, params);
    },
    updateGroup : async (params) => {
        const url = `v2/documents/group/${params.id}`;
        return await requestv2.patch(url, params);
    },
    deleteGroup : async (id) => {
        const url = `v2/documents/group/${id}`;
        return await requestv2.delete(url);
    },

    getsItem : async (params) => {
        const url = 'v2/documents';
        return await requestv2.get(url, {params});
    },
    addItem : async (params) => {
        const url = 'v2/documents';
        return await requestv2.post(url, params);
    },
    updateItem : async (params) => {
        const url = `v2/documents/${params.id}`;
        return await requestv2.patch(url, params);
    },
    deleteItem : async (id) => {
        const url = `v2/documents/${id}`;
        return await requestv2.delete(url);
    },
    fileUpload : async (params) => {
        const url = `v2/documents/file`;
        return await requestv2.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    fileRemove : async (params) => {
        const url = `v2/documents/file/delete`;
        return await requestv2.post(url, params);
    },
};

export default documentApi;